import * as React from 'react';
import { Card } from '../../../node_modules/@blueprintjs/core';
import CardContainer from '../common/CardContainer';
import FormTextbox from '../controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import Form from '../controls/forms/Form';
import FormRow from '../controls/forms/FormRow';
import Button from '../controls/forms/redesign/FormButton';
import PropertyUtil from 'src/util/PropertyUtil';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { ODataOptions } from 'src/util/ODataBuilder';
import { AnyObject } from 'final-form';
import './AddClient.scss';
import Client from 'src/models/Client';
import { RouteComponentProps } from 'react-router';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { connect } from 'react-redux';

export interface IEditClientPageStateProps {
    errorMessage: string;
    isLoading: boolean;
    states: PagedResultSet<State>;
    client: (clientNumber: number) => Client;
}

export interface IEditClientPageDispatchProps {
    editClient: (client: Client) => void;
    getStates: (options: ODataOptions) => void;
    getClientByNumber: (clientNumber: number) => void;
}

type IEditClientPageProps = RouteComponentProps<{ clientNumber?: string }> & IEditClientPageStateProps & IEditClientPageDispatchProps;

class EditClientPage extends React.Component<IEditClientPageProps> {
    phoneDefaultEditClient = (client: Client) => {
        if (client.phoneNumber) {
            client.phoneNumber.isPrimary = true;
            client.phoneNumber.typeId = 2; // 2 is office
        }

        client.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.props.editClient(client);
    };

    validate = (client: Client) => {
        // TODO: Add ability to map Deep objects in FormErrors. Use AnyObject for now
        const errors: AnyObject = {};
        errors.address = {};
        errors.phoneNumber = {};

        errors.cloakName = 'Name required';
        if (client.cloakName !== undefined) {
            errors.cloakName = undefined;
        }
        if (client.isShadow) {
            errors.address = undefined;
            errors.phoneNumber = undefined;
            return errors;
        }

        errors.address.addressLine1 = 'Address Line 1 required';
        errors.address.city = 'City required';
        errors.address.state = 'State required';
        errors.address.zipCode = 'Zipcode required';
        errors.phoneNumber.number = 'Phone number required';
        if (client.address) {
            if (client.address.addressLine1) {
                errors.address.addressLine1 = undefined;
            }
            if (client.address.city) {
                errors.address.city = undefined;
            }
            if (client.address.state) {
                errors.address.state = undefined;
            }
            if (client.address.zipCode) {
                errors.address.zipCode = undefined;
            }
            if (client.address.addressLine1 && client.address.city && client.address.state && client.address.zipCode) {
                errors.address = undefined;
            }
        }
        if (client.phoneNumber) {
            if (client.phoneNumber.number) {
                errors.phoneNumber.number = undefined;
            }
        }

        return errors;
    };

    componentDidMount() {
        const clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.props.getClientByNumber(clientNumber);
        this.props.getStates(new ODataOptions().addPaging(1, 100));
    }

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();
        const client = this.props.client(parseInt(this.props.match.params.clientNumber, 10));
        const selectedItem = PropertyUtil.SafeGet(() => this.props.client(parseInt(this.props.match.params.clientNumber, 10)));
        return (
            <CardContainer>
                <Card elevation={1} className="lh-form-panel">
                    <Form onSubmit={this.phoneDefaultEditClient} validate={this.validate} initialValues={selectedItem}>
                        <FormTextbox className="header" label="Client Name" name="cloakName" />
                        <>
                            {client && !client.isShadow && (
                                <>
                                    <FormTextbox label="Address Line 1" name="address.addressLine1" />
                                    <FormTextbox label="Address Line 2" name="address.addressLine2" />
                                    <FormRow className="city-state-zip">
                                        <FormTextbox label="City" name="address.city" />
                                        <FormSelect label="State" name="address.state.id" items={selectStates} />
                                        <FormTextbox label="Zipcode" name="address.zipCode" />
                                    </FormRow>
                                    <div className="footer">
                                        <FormTextbox label="Phone Number" name="phoneNumber.number" />
                                        <FormTextbox label="Website" name="webSite" />
                                    </div>
                                </>
                            )}
                        </>

                        <Button type="submit" text="Submit" intent="Primary" />
                    </Form>
                </Card>
            </CardContainer>
        );
    }
}

const mapStateToProps = (state: IRootState): IEditClientPageStateProps => ({
    isLoading: selectors.client.isSubmittingEditClient(state),
    errorMessage: selectors.client.editClientError(state),
    states: state.state.states,
    client: (clientNumber: number) => selectors.client.client(state),
});

const mapDispatchToProps: IEditClientPageDispatchProps = {
    editClient: (client: Client) => actions.client.editClient(client),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
    // getClients: () => actions.client.getClients(),
    getClientByNumber: (clientNumber: number) => actions.client.getClient(clientNumber),
};

export default connect(mapStateToProps, mapDispatchToProps)(EditClientPage);



// WEBPACK FOOTER //
// ./src/components/clients/EditClientPage.tsx